import { lazy } from 'react';
import { Route, Routes } from 'react-router-dom';

const PageNotFound = lazy(() => import('@components/error/404/PageNotFound'));
const HomePage = lazy(() => import('@shared/layout/dashboard/components/home/HomePage'));
const ProfilePage = lazy(() => import('@shared/layout/dashboard/components/profile-page/ProfilePage'));
const TopDentistsCustomersPage = lazy(() => import('@shared/layout/dashboard/components/top-dentists-customers/TopDentistsCustomersPage'));

const LabOrdersPage = lazy(() => import('./orders/LabOrdersPage'));

const LaboratoryRouter = () => (
  <Routes>
    <Route path="profile/:id" element={<ProfilePage />} />
    <Route path="lab-orders/:status" element={<LabOrdersPage />} />
    <Route path="top-customers" element={<TopDentistsCustomersPage />} />
    <Route index element={<HomePage />} />
    <Route path="*" element={<PageNotFound />} />
  </Routes>
);

export default LaboratoryRouter;
